<main *ngIf="merchantsLoaded && profileLoaded"  [@routeAnimations]="prepareRoute(outlet)">
    <router-outlet #outlet="outlet"></router-outlet>
</main>